module.exports = __webpack_public_path__ + "img/01.d913f75f.png";